import { AxiosRequestConfig } from "axios";
import { jwtDecode } from "jwt-decode";
import { CohesiveAPIClient } from "../../client";
import {
  DecodedToken,
  MeData,
  MeResponse,
  UpdateUserInfoPayload,
} from "./types";

export * from "./types";

const ENDPOINTS = {
  SHOW: "/api/v2/me",
  UPDATE: "/api/v2/me",
  CHANGE_PASSWORD: "/api/v2/me/change-password",
};

export class UserAPI {
  constructor(private client: CohesiveAPIClient) {}

  async show(config?: AxiosRequestConfig): Promise<MeData> {
    const token = await this.client.getToken();
    const decodedToken = jwtDecode(token as string) as DecodedToken;
    const response = await this.client.axios.get<MeResponse>(
      ENDPOINTS.SHOW,
      config,
    );
    return {
      ...response.data.data,
      permissions: decodedToken.permissions,
    };
  }

  async update(
    data: UpdateUserInfoPayload,
    config?: AxiosRequestConfig,
  ): Promise<MeResponse["data"]> {
    const response = await this.client.axios.put<
      MeResponse["data"],
      any,
      UpdateUserInfoPayload
    >(ENDPOINTS.UPDATE, data, config);
    return response.data;
  }

  async changePassword(config?: AxiosRequestConfig): Promise<void> {
    await this.client.axios.post(ENDPOINTS.CHANGE_PASSWORD, {}, config);
  }
}
